import { type ReactNode, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { SyncStatusBar } from './components/SyncStatusBar';
import { useAuth } from './hooks/useAuth';
import { registerSyncTriggers } from './lib/sync';
import { LoginPage } from './pages/LoginPage';
import { NewExpensePage } from './pages/NewExpensePage';
import { TripDetailPage } from './pages/TripDetailPage';
import { TripsListPage } from './pages/TripsListPage';

function AppLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-bg">
      <SyncStatusBar />
      <div className="flex flex-1 flex-col">{children}</div>
    </div>
  );
}

export function App() {
  const { isAuthenticated } = useAuth();

  // Tenta esvaziar a fila de sincronização sempre que a conexão volta (RF-VIA-04).
  useEffect(() => registerSyncTriggers(), []);

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/viagens" replace /> : <LoginPage />}
      />
      <Route
        path="/viagens"
        element={
          <ProtectedRoute>
            <AppLayout>
              <TripsListPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/viagens/:tripId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <TripDetailPage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/viagens/:tripId/novo-gasto"
        element={
          <ProtectedRoute>
            <AppLayout>
              <NewExpensePage />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to={isAuthenticated ? '/viagens' : '/login'} replace />} />
    </Routes>
  );
}
